<script lang="ts" setup></script>

<template>
    <div class="landing-page">
        <HeroSection />
        <WhatIsSection id="study" />
        <WhyParticipateSection id="benefits" />
        <HowParticipateSection id="how-it-works" />
        <FaqSetion id="faq" />
    </div>
</template>

<style scoped>
@import "@styles/breakpoints.css";
.landing-page {
    display: flex;
    flex-direction: column;
    @media (--medium-viewport) {
        gap: 7.5rem;
    }
}
</style>
